<script setup lang="ts">
// Components of Module
import { YandexMapFeature } from 'vue-yandex-maps'

// Types
import { LngLat, YMapFeatureProps } from '@yandex/ymaps3-types'
import { AreaProperties } from '@/api/modules/delivery/types'
type Props = {
  areas?: AreaProperties[]
}

withDefaults(defineProps<Props>(), {
  areas: () => [],
})

// Инверсия координат lat lon значений
const reverseCoords = (area: AreaProperties) => {
  try {
    return [
      area.polygon[0].map(
        (coordinate): LngLat => [coordinate[1], coordinate[0]],
      ),
    ]
  } catch (_) {
    return []
  }
}

const generateSettings = (area: AreaProperties): YMapFeatureProps => {
  return {
    properties: { ...area.properties },
    geometry: { type: 'Polygon', coordinates: reverseCoords(area) },
    style: {
      fillOpacity: 0.3,
      fill: area.properties.stroke,
      stroke: [{ opacity: 0 }],
    },
  }
}
</script>

<template>
  <yandex-map-feature
    v-for="area in areas"
    :key="area.id"
    :settings="generateSettings(area)"
  />
</template>
